export default __webpack_public_path__ + "static/media/exhibitor-icon.d0057081.svg";